// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top2{display:flex;flex-direction:row;justify-content:space-between;margin-top:15px;width:100%}.opr{width:40px;line-height:20px;font-size:12px;color:#35b9ff;cursor:pointer}", ""]);
// Exports
module.exports = exports;
